import { type ReactNode, type Ref } from 'react'
import { createPortal } from 'react-dom'
import { useFrame } from '@/lib/frame'
import { InBar } from '@/lib/inBar'

// A page's own top row (its views, search, Filter). On a phone, off Home, it moves up into the top bar between back
// and the "+", so the page starts right under the clock: only Home keeps the logo there (Dallas, 2026-10-17). It
// then tucks away and comes back with the bar, unless it's `pinned`: then the bar stays put while it's there, as
// Photos' tabs stay at the top. Elsewhere it stays where it is, drawn with `className`.
export function BarRow({
  className,
  barClassName = 'flex min-w-0 flex-1 items-center gap-2',
  pinned,
  ref,
  children,
}: {
  className?: string
  barClassName?: string
  pinned?: boolean
  ref?: Ref<HTMLDivElement>
  children: ReactNode
}) {
  const { rowSlot } = useFrame()
  if (!rowSlot) {
    return (
      <div ref={ref} className={className}>
        {children}
      </div>
    )
  }
  return createPortal(
    <InBar value>
      <div ref={ref} className={barClassName} data-keep-bar={pinned || undefined}>
        {children}
      </div>
    </InBar>,
    rowSlot,
  )
}
